import { post } from '../../../axios';

export const completeOrder = async (orderId: number) => {
  const { data } = await post(`order/${orderId}/complete`, '');
  return data;
};
